import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CollaboratorService } from './../../../../../rest/api/collaborator.service';
import { HelperService } from './../../../../../services/helper.service';
import { AuthService } from './../../../../../services/auth.service';

@Component({
  selector: 'app-role-reactivate-collaborator',
  templateUrl: './role-reactivate-collaborator.component.html',
  styleUrls: ['./role-reactivate-collaborator.component.scss']
})
export class RoleReactivateCollaboratorComponent implements OnInit {

  @Input() collaborator;
  @Input() selectedCollaborator;
  @Output() reactivateCollaboratorEmit = new EventEmitter();

  accessToken: any;
  successMsg: string;
  errorMsg: string;
  reactivateSuccessMsg: any;
  reactivatePendingMsg: any;
  reactivateErrorMsg: any;
  isSubmitting = false;
  isSubmitted = false;
  errors = [];

  constructor(
    private authService: AuthService,
    public helperService: HelperService,
    public collaboratorService: CollaboratorService,

  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
  }

  handleErrors(err) {
    if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errors = err.error.errors;
    } else if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.reactivateErrorMsg = err.error.error;
    } else {
      this.reactivateErrorMsg = 'This user is already a collaborator in your company.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  reactivateCollaborator(collaborator) {
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrorValues();
    this.collaboratorService.reactivateCollaborator({
      Authorization: this.accessToken,
      id: collaborator.uuid
    }).subscribe((response: any) => {
      if (response && response.data && response.data.status === 'active') {
        this.reactivateSuccessMsg = 'This email has been reactivated, and is now listed as active.';
      } else {
        this.reactivatePendingMsg = 'This email has been re-invited, and is now listed as pending.';
      }
      setTimeout(() => {
        this.reactivateCollaboratorEmit.emit(response && response.data ? response.data : undefined);
        this.resetErrorValues();
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetErrorValues() {
    this.reactivateSuccessMsg = undefined;
    this.reactivatePendingMsg = undefined;
    this.reactivateErrorMsg = undefined;
    this.errors = [];
  }

  resetErrors() {
    this.reactivateSuccessMsg = undefined;
    this.reactivatePendingMsg = undefined;
    this.reactivateErrorMsg = undefined;
    this.errors = [];
  }

}
